import { useTranslation } from "react-i18next";

const asArray = (v) => (Array.isArray(v) ? v : []);

export const AboutTeamSection = () => {
  const { t } = useTranslation("about");

  const s2List = t("team.youssef.s2List", { returnObjects: true });
  const s5List = t("team.youssef.s5List", { returnObjects: true });
  const maryamItems = t("team.maryam.items", { returnObjects: true });
  const aminaItems = t("team.amina.items", { returnObjects: true });

  return (
    <section className="about-section-s2">
      <div className="container">
        <div className="wrap">
          <div className={"row align-items-center justify-content-center"}>
            <div className="col-12">
              <div className="section-title">
                <h2 className="">{t("team.heading")}</h2>
                <div className="row">
                  <div className="col-12">
                    <h3 className="">{t("team.youssef.name")}</h3>
                    <h4 className="text-start">{t("team.youssef.fullName")}</h4>
                    <p className="text-start mb-3">{t("team.youssef.origin")}</p>

                    <h4 className="text-start">{t("team.youssef.s1Head")}</h4>
                    <p className="text-start mb-3">{t("team.youssef.s1Body")}</p>

                    <h4 className="text-start">{t("team.youssef.s2Head")}</h4>
                    <p className="text-start">{t("team.youssef.s2Intro")}</p>
                    <ul>
                      {asArray(s2List).map((item, i) => (
                        <li key={i}>
                          <p className="text-start">{item}</p>
                        </li>
                      ))}
                    </ul>
                    <p className="text-start mb-3">{t("team.youssef.s2Outro")}</p>

                    <h4 className="text-start">{t("team.youssef.s3Head")}</h4>
                    <p className="text-start mb-3">{t("team.youssef.s3Body")}</p>

                    <h4 className="text-start">{t("team.youssef.s4Head")}</h4>
                    <p className="text-start mb-3">{t("team.youssef.s4Body")}</p>

                    <h4 className="text-start">{t("team.youssef.s5Head")}</h4>
                    <p className="text-start">{t("team.youssef.s5Intro")}</p>
                    <ul>
                      {asArray(s5List).map((item, i) => (
                        <li key={i}>
                          <p className="text-start">{item}</p>
                        </li>
                      ))}
                    </ul>
                    <p className="text-start mb-3">{t("team.youssef.s5Outro")}</p>

                    <h4 className="text-start">{t("team.youssef.s6Head")}</h4>
                    <p className="text-start mb-3">{t("team.youssef.s6Body")}</p>

                    <h4 className="text-start">{t("team.youssef.s7Head")}</h4>
                    <p className="text-start mb-3">{t("team.youssef.s7Body")}</p>

                    <p className="text-start">{t("team.youssef.closing")}</p>
                  </div>
                  <div className="col-lg-6 col-12 mt-5">
                    <h3 className="">{t("team.maryam.name")}</h3>
                    <ul className="list-group">
                      {asArray(maryamItems).map((item, i) => (
                        <li className="list-group-item text-start" key={i}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-lg-6 col-12 mt-5">
                    <h3 className="">{t("team.amina.name")}</h3>
                    <ul className="list-group">
                      {asArray(aminaItems).map((item, i) => (
                        <li className="list-group-item text-start" key={i}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
